import { useQuery } from "@apollo/client/react";

import { GET_SCAN_SETTINGS } from "./gql";

const useGetScanSettings = (scanId: string | undefined) => {
  const { data, error, loading } = useQuery(GET_SCAN_SETTINGS, {
    variables: { id: scanId ?? "" },
    skip: !scanId,
  });

  return {
    scanSettings: data?.scan,
    error,
    loading,
  };
};

export default useGetScanSettings;
